import styled from 'styled-components';
import {textSizes} from '@stencil/build-theme/src/build-theme';

const FlexItem = styled.div(
  props => `
      display:flex;
      `,
);

export const CalenderOuterWrapper = styled.section(
  props => `
  width:74.5rem;
  display: flex;
  flex-direction: column;
  // padding: 25px 17px 10px 17px;
  border-radius: 12px;
  box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.16);
  background:white;
    `,
);

export const CalenderMonthContainer = styled.div(
  props => `
    display:flex;
    flex: 1;
    flex-direction:column;
    `,
);

export const MonthOuterWrapper = styled(FlexItem)(
  props => `
  margin-bottom: ${props.theme.spacing.large};  
  `,
);

export const HolidayText = styled.p(
  props => `
  margin-bottom: ${props.theme.spacing.base};
  color: ${props.theme.colors.downriver.medium};
  text-transform: uppercase;
  padding-left: ${props.theme.spacing.custom(25)};
  `,
);

export const HolidayDetailsDate = styled.ul(
  props => `
  display: flex;
  overflow-y: hidden;
  white-space: nowrap;
  padding:0px 25px 10px 15px;
  li{
    display:flex;
    margin-right:${props.theme.spacing.base};
    padding:10px;
    align-items: center;
    &:last-child{
        margin-right:0;
    }
  `,
);

export const GreenHoliday = styled.span(
  props => `
  width:8px;
  height:8px;
  border-radius:50%;
  margin-right:${props.theme.spacing.base};
  background:green;
  flex-shrink: 0;
  `,
);

export const HolidayDate = styled.span(
  props => `
  font-weight:bold;
  font-size: ${props.theme.font.custom(14)};
  margin-right:${props.theme.spacing.base};
  `,
);

export const FestivalName = styled.span(
  props => `
  font-size: ${props.theme.font.custom(14)};
  color:${props.theme.colors.goBrandOrange.base};
  `,
);

export const LeftMonthHeaderWrapper = styled.div(
  props => `
  display: flex;
  align-items: center;
  margin-bottom:${props.theme.spacing.base};
  justify-content: center;
  width:100%;
  position: relative;
  padding:25px 10px;

  `,
);

export const CircularWrapperLeft = styled.span(
  props => `
  display:flex;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.25);
  background-color:white;
  width:3.6rem;
  height:3.6rem;
  flex-shrink:0;
  align-items: center;
  justify-content:center;
  border-radius: ${props.theme.misc.borderRadius.custom(50)};
  position: absolute;
  left:3rem;
  cursor:pointer;
  opacity: ${props.disabled ? 0.4 : 1};
  `,
);

export const CircularWrapperRight = styled.span(
  props => `
  display:flex;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.25);
  background-color:white;
  width:3.6rem;
  height:3.6rem;
  flex-shrink:0;
  align-items: center;
  justify-content:center;
  border-radius: ${props.theme.misc.borderRadius.custom(50)};
  position: absolute;
  right:3rem;
  cursor:pointer;
  opacity: ${props.disabled ? 0.4 : 1};
  `,
);

// export const MonthName = styled.span(`${textSizes.LargeW2};`);
export const MonthName = styled.span`
  ${textSizes.LargeW2};
`;

export const CalendarMainWrapperDiv = styled.div(
  props => `
    display: flex;
    flex-flow: row wrap;
    width: 100%;
  `,
);

export const DayAndDateLeftWrapper = styled.div(
  props => `
  width: 100%;
  display: flex;
  flex-direction: column;
  border-right:1px solid #e5edf6;
  padding-top:${props.theme.spacing.xsmall};
  padding-left:${props.theme.spacing.xxlarge};
  padding-right:${props.theme.spacing.xxlarge};
  padding-bottom:${props.theme.spacing.small};
  `,
);

export const DayAndDateRightWrapper = styled.div(
  props => `
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-top:${props.theme.spacing.xsmall};
  padding-left:${props.theme.spacing.xxlarge};
  padding-right:${props.theme.spacing.xxlarge};
  padding-bottom:${props.theme.spacing.small};
  `,
);

export const DayWrapDiv = styled.ul(
  props => `
  display: flex;
  flex-wrap:wrap;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
      li{
        width:4.5rem;
        height:3.5rem;
        justify-content: center;
        display: flex;
        flex-wrap:wrap;
        flex-direction: column;
        align-items: center;
        font-size:${props.theme.font.custom(14)};
        color:${props.theme.colors.downriver.medium};
        font-weight:500;
      }
  `,
);

export const DateWrapDiv = styled.ul`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  position: relative;
  flex-wrap: wrap;
  justify-content: flex-start;
  li {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    width: 4.5rem;
    height: 4.5rem;
    justify-content: center;
    position: relative;
    div {
      width: 6px;
      height: 6px;
      background: green;
      border-radius: 50%;
      position: absolute;
      left: 45%;
      bottom: 0px;
    }
    span {
      ${textSizes.MediumW2};
      width: 100%;
      display: flex;
      flex-direction: column;
      color: black;
      align-items: center;
      &:hover {
        width: 5rem;
        height: 5rem;
        background-color: ${props => props.theme.colors.goBrandBlue.light};
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
      &.partial {
        width: 5rem;
        height: 5rem;
        background-color: ${props => props.theme.colors.goBrandBlue.light};
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
      &.leftactive {
        font-weight: bold;
        width: 5rem;
        height: 5rem;
        background-color: #2276e3;
        display: flex;
        flex-direction: column;
        color: ${props => props.theme.colors.goWhite.base};
        justify-content: center;
        border-radius: 8px;
        // border-top-left-radius: 50%;
        // border-bottom-left-radius: 50%;
      }
      &.rightactive {
        font-weight: bold;
        width: 5rem;
        height: 5rem;
        background-color: #2276e3;
        display: flex;
        flex-direction: column;
        color: ${props => props.theme.colors.goWhite.base};
        justify-content: center;
        border-radius: 8px;
      }
    }
  }
`;
